import UniversalModal from './UniversalModal';

/**
 * Modal - Legacy wrapper around UniversalModal
 * Maintained for backwards compatibility with existing code
 * Uses portal rendering and simple content padding
 *
 * @deprecated Use UniversalModal directly for new code
 */
export default function Modal({ isOpen, onClose, title, children, size = 'md', zIndex = 50 }) {
  return (
    <UniversalModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      zIndex={zIndex}
      usePortal={true}
    >
      <div className="p-6">
        {children}
      </div>
    </UniversalModal>
  );
}
